<template>
  <div class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-gutter-md justify-center">
        <div class="col-12 corner">
          <q-btn color="primary" @click="toAddReceivable" label="添加应收账款" icon="payment" />
        </div>
        <div class="col-md-3 col-11">
          <q-select outlined v-model="queryForm.customerNo" :options="customerList" option-label="customerName"
            option-value="customerNo" emit-value map-options label="客户" dense clearable />
        </div>
        <div class="col-11 col-md-3">
          <q-select v-model="queryForm.invoiceStatus" label="开票状态" dense clearable outlined emit-value map-options
            :options="[
              { value: '0', label: '未开票' },
              { value: '1', label: '已开票' },
            ]">
            <template v-slot:prepend>
              <q-icon name="date_range" />
            </template>
          </q-select>
        </div>
        <div class="col-11 col-md-3">
          <q-select v-model="queryForm.status" label="状态" dense clearable outlined emit-value map-options :options="[
            { value: '0', label: '未付款' },
            { value: '1', label: '部分付款' },
            { value: '2', label: '已结清' },
          ]">
            <template v-slot:prepend>
              <q-icon name="date_range" />
            </template>
          </q-select>
        </div>
        <div class="col-md-3 col-11">
          <q-input outlined dense v-model="queryForm.beginTime" label="开票开始日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm.beginTime" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-input outlined dense v-model="queryForm.endTime" label="开票结束日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm.endTime" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn label="重置" type="reset" color="primary" flat class="q-ml-sm" />
        </div>
      </div>
    </q-form>

    <q-table ref="mytable" title="应收帐款信息" :data="tableData.list" :columns="columns" row-key="id"
      :pagination.sync="pagination" :loading="loading" @request="request" binary-state-sort separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]">
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn round color="primary" size="xs" icon="edit" @click="detail(props.row)" />
            <q-btn round color="deep-orange" size="xs" icon="delete_forever" @click="remove(props.row)" />
          </div>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <q-tr v-if="tableData.sumMap">
          <q-td align="center"> 合计 </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.totalReceivable).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.totalPaid).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.totalBalance).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td> </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { listAll } from "@/api/erp/customer.js";
import { listReceivable } from "@/api/erp/finance/receivable";
import numbro from "numbro";
export default {
  components: {},
  data() {
    return {
      numbro,
      queryForm: { pageNum: 1, pageSize: 10 },
      tableData: { sumMap: {} },
      loading: false,
      customerList: [],
      pagination: {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "customerName",
          align: "center",
          label: "客户名称",
          field: (row) => row.customer.customerName,
        },
        {
          name: "INVOICE_DATE",
          align: "center",
          label: "开票日期",
          field: "invoiceDate",
          sortable: true,
        },
        {
          name: "TOTAL",
          align: "center",
          label: "应收帐款金额",
          field: (row) =>
            numbro(row.total || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
          sortable: true,
        },
        {
          name: "AMOUNT_PAID",
          align: "center",
          label: "已收金额",
          field: (row) =>
            numbro(row.amountPaid || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
          sortable: true,
        },
        {
          name: "AMOUNT_BALANCE",
          align: "center",
          label: "未收金额",
          field: (row) =>
            numbro(row.amountBalance || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
          sortable: true,
        },
        {
          name: "invoiceStatus",
          align: "center",
          label: "开票状态",
          field: (row) => {
            let formatter = "";
            if ("0" == row.invoiceStatus) {
              formatter = "未开票";
            } else if ("1" == row.invoiceStatus) {
              formatter = "已开票";
            }
            return formatter;
          },
        },
        {
          name: "status",
          align: "center",
          label: "状态",
          field: (row) => {
            let formatter = "";
            if ("0" == row.status) {
              formatter = "未付款";
            } else if ("1" == row.status) {
              formatter = "部分付款";
            } else if ("2" == row.status) {
              formatter = "已结清";
            }
            return formatter;
          },
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  mounted() {
    this.listCustomer();
    this.query();
  },
  methods: {
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      if (sortBy) {
        self.queryForm.orderBy = sortBy + (descending ? " desc" : " asc");
      } else {
        self.queryForm.orderBy = null;
      }
      listReceivable(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
    listCustomer() {
      var self = this;
      listAll().then((response) => {
        self.customerList = response.data.data;
      });
    },
    toAddReceivable() {
      this.$router.push("/receivable/add");
    },
    detail(row) {
      this.$router.push("/receivable/detail/" + row.id);
    },
  },
};
</script>

<style scoped>
.corner {
  flex-direction: row-reverse;
  display: flex;
}

#queryForm {
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
</style>